<script setup>
/* Avatar generato localmente, non Gravatar.
 *
 * L'originale usava `//gravatar.com/avatar/${hash}` (protocol-relative e
 * hardcoded in due componenti). Tre problemi: è una richiesta a un dominio
 * esterno da un'app che gira su tailnet — quindi fallisce quando la rete non
 * c'è e smentisce la promessa "PWA offline"; comunica a un terzo chi guarda
 * cosa e quando; e l'hash è l'md5 dell'email, bruteforzabile su dizionari di
 * indirizzi noti.
 *
 * Il monogramma è deterministico: dallo stesso username esce sempre la stessa
 * tinta, quindi le persone restano riconoscibili a colpo d'occhio.
 */
import { computed } from 'vue';

const props = defineProps({
  username: { type: String, default: '' },
  size: { type: Number, default: 24 },
});

const initial = computed(() => (props.username?.trim()?.[0] ?? '?').toUpperCase());

const hue = computed(() => {
  let hash = 0;
  for (const char of props.username ?? '') {
    hash = (hash * 31 + char.charCodeAt(0)) % 360;
  }
  return hash;
});
</script>

<template>
  <span
    class="avatar"
    :style="{
      '--size': `${size}px`,
      '--hue': hue,
    }"
    aria-hidden="true"
    >{{ initial }}</span
  >
</template>

<style scoped>
.avatar {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  /* Saturazione e luminosità basse: l'avatar non deve competere con le
     immagini, che sono il contenuto. */
  background: hsl(var(--hue) 32% 88%);
  color: hsl(var(--hue) 42% 28%);
  font-size: calc(var(--size) * 0.46);
  font-variation-settings: 'wdth' 100;
  font-weight: 700;
  line-height: 1;
  user-select: none;
}

:root[data-theme='dark'] .avatar {
  background: hsl(var(--hue) 26% 24%);
  color: hsl(var(--hue) 46% 78%);
}
</style>
